export enum EConditionType {
  OfficeDecoration = 'officeDecoration',
  FullDecorationNeeded = 'fullDecorationNeeded',
  MajorRepairNeeded = 'majorRepairNeeded',
  CosmeticRepairNeeded = 'cosmeticRepairNeeded',
  RegularRepair = 'regularRepair',
  DesignerRepair = 'designerRepair',
  WithDecoration = 'withDecoration',
}
